export const CONTACT_US = [
  {
    icon: "/about-us/74.招聘.svg",
    title: "招贤纳士",
    description: "加入 PingCAP，用科技改变世界",
    linkName: "了解更多",
    link: "/join-us",
  },
  {
    icon: "/about-us/59.邮件.svg",
    title: "联系我们",
    description:
      "对 TiDB 产品、技术支持、合作等有任何问题，请通过这些渠道跟我们联系",
    linkName: "了解更多",
    link: "/contact",
  },
]

export const VALUE_AND_MISSION = {
  title: "我们的使命和价值观",
  mission: {
    title: "我们的使命",
    description: "为开发者和企业赋能，以速度、敏捷、增长之道创新",
  },
  value: {
    title: "我们的价值观",
    description:
      "客户成功；达成结果，追求卓越；开放；勇于担当；彼此尊重，成就他人；理想远大，不同凡响",
  },
}

export const ABOUT_US_NEWS_TYPE_VALUE = ["detail", "link"]
export const ABOUT_US_COVER_NEWS_TYPE_VALUE = ["enterpriseNews", "mediaReports"]
